import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "count", "estimate"]
  static values = {
    cjkCharactersPerSecond: Number,
    minimum: Number,
    nonSpaceScriptCharactersPerSecond: Number,
    rate: Number,
    wordsPerSecond: Number,
    characterCountTemplate: String,
    estimateTemplate: String
  }

  connect() {
    this.update()
  }

  update() {
    const text = this.inputTarget.value || ""
    this.countTarget.textContent = this.characterCountTemplateValue.replace("__COUNT__", text.length)

    const cjkRegex = /[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}]/gu
    const nonSpaceScriptRegex = /[\p{Script=Thai}\p{Script=Lao}\p{Script=Khmer}\p{Script=Myanmar}]/gu
    const cjkCharacters = text.match(cjkRegex) || []
    const nonSpaceScriptCharacters = text.match(nonSpaceScriptRegex) || []
    const nonCjkText = text.replace(cjkRegex, " ")
    const countableWordText = nonCjkText.replace(nonSpaceScriptRegex, " ")
    const wordMatches = countableWordText.match(/[\p{Letter}\p{Number}'-]+/gu) || []
    const estimatedSeconds =
      (wordMatches.length / this.wordsPerSecondValue) +
      (cjkCharacters.length / this.cjkCharactersPerSecondValue) +
      (nonSpaceScriptCharacters.length / this.nonSpaceScriptCharactersPerSecondValue)
    const seconds = Math.max(Math.round(estimatedSeconds * 10) / 10, text.trim().length > 0 ? 3 : 0)
    const rawCost = seconds * this.rateValue
    const cost = seconds > 0
      ? Math.round(Math.max(this.minimumValue, rawCost) * 100) / 100
      : 0

    this.estimateTarget.textContent = this.estimateTemplateValue
      .replace("__SECONDS__", seconds || 0)
      .replace("__COST__", `$${cost.toFixed(2)}`)
  }
}
